/* eslint-disable
    react/prefer-stateless-function
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import SortableTable from 'ui-library/SortableTable';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

const {defaultColumn} = SortableTable;

class ProjectOpenReviews extends React.Component {
  static propTypes = {
    openReviews: PropTypes.arrayOf(
      PropTypes.shape({
        entryName: PropTypes.string.isRequired,
        entryURL: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        authors: PropTypes.array.isRequired,
        auditors: PropTypes.array.isRequired,
      })
    ).isRequired,
  };

  render() {
    const columns = [
      defaultColumn('Entry Name', 'entryName', {
        render(entryNameColumn, entryRow, props) {
          return (
            <span>
              {entryRow.entryName}
              <a href={entryRow.entryURL} className="u-tiny-spacing-left">
                <BenchlingIcon icon="link" />
              </a>
            </span>
          );
        },
      }),
      defaultColumn('Status', 'status', {
        transform(value) {
          return capitalize(constantCaseToWords(value));
        },
      }),
      defaultColumn('Authors', 'authors'),
      defaultColumn('Auditors', 'auditors'),
    ];
    const rows = this.props.openReviews;
    return (
      <div>
        <h4>{`Open Reviews (${rows.length})`}</h4>
        <SortableTable columns={columns} rows={rows} />
      </div>
    );
  }
}

export default ProjectOpenReviews;
